package com.schoolconnect.app.datasource.network.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonElement

@Serializable
data class ParentResponse(
    @SerialName("school_id")
    val schoolId: String? = null,
    @SerialName("user_id")
    val userId: String? = null,
    @SerialName("mobile")
    val mobile: String? = null,
    @SerialName("email")
    val email: String? = null,
    @SerialName("mobile_verified")
    val mobileVerified: Boolean? = null,
    @SerialName("email_verified")
    val emailVerified: Boolean? = null,
    @SerialName("name")
    val name: String? = null,
    @SerialName("custom_attributes")
    val customAttributes: Map<String, JsonElement>? = null,
    @SerialName("is_active")
    val isActive: Boolean? = null,
    @SerialName("push_notification_enabled")
    val pushNotificationEnabled: Boolean? = null,
    @SerialName("email_notification_enabled")
    val emailNotificationEnabled: Boolean? = null,
    @SerialName("profile_image_url")
    val profileImageUrl: String? = null,
    @SerialName("id")
    val id: String? = null,
    @SerialName("created_at")
    val createdAt: String? = null,
    @SerialName("created_by_id")
    val createdById: String? = null,
    @SerialName("updated_at")
    val updatedAt: String? = null,
    @SerialName("updated_by_id")
    val updatedById: String? = null
)
